module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_2_PL-44b59ecea60c053659d367bf43c8ef4f.svg";